import React, { useEffect, useState, useContext } from 'react';

import ReleaseDialog from 'App/components/Maintenance/ReleaseDialog';
import { EVENT_MAINTENANCE } from 'App/components/WebSocket/constants';

import { useChildComponent, usePrevious } from '@gogame/hooks-ts';
import { useSubscribe } from '@gogame/hooks-ts';
import { useSocket } from '@gogame/sockets';
import { useLoadReleaseVersion } from './data';

const MaintenanceContext = React.createContext({});

const notifyNewRelease = `${process.env.REACT_APP_NOTIFY_NEW_RELEASE}` === '1';
const buildRelease = `${process.env.REACT_APP_BUILD_RELEASE}`;

export const useIsMaintenance = () => {
  return useContext(MaintenanceContext)?.isMaintenance;
};

const MaintenanceProvider = ({ children }) => {
  const [childComponent, showChildComponent] = useChildComponent(null);
  const [isMaintenance, setMaintenance] = useState(false);

  const prevIsMaintenance = usePrevious(isMaintenance);
  const socket = useSocket();

  const { data, refetch } = useLoadReleaseVersion({
    enabled: notifyNewRelease && childComponent === null,
  });

  useEffect(() => {
    if (
      notifyNewRelease &&
      childComponent === null &&
      data &&
      data.version !== buildRelease
    ) {
      /* eslint-disable-next-line */
      console.log(
        `!!!! DIFFERENT RELEASE VERSIONS !!!!
        current = ${buildRelease},
        file = ${data.version}`,
        { isMaintenance }
      );

      if (!isMaintenance) {
        showChildComponent(ReleaseDialog);
      }
    }
  }, [data, isMaintenance, childComponent, showChildComponent]);

  useSubscribe(() => {
    const handleMaintenanceStatus = async ({ status }) => {
      setMaintenance(status);
    };
    socket.on(EVENT_MAINTENANCE, handleMaintenanceStatus);
    return () => {
      socket.off(EVENT_MAINTENANCE, handleMaintenanceStatus);
    };
  }, [socket, setMaintenance]);

  useEffect(() => {
    if (prevIsMaintenance && !isMaintenance) {
      if (notifyNewRelease) {
        refetch();
      } else {
        /* eslint-disable-next-line */
        console.log(
          '!!! Release version should be checked, but is not allowed in the environment'
        );
      }
    }
  }, [prevIsMaintenance, isMaintenance, notifyNewRelease, refetch]);

  return (
    <MaintenanceContext.Provider value={{ isMaintenance }}>
      {childComponent}
      {children}
    </MaintenanceContext.Provider>
  );
};

export default MaintenanceProvider;
